import { styled as styledMui, Box, IconButton } from "@mui/material";

export const BarContainer = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  width: "100%",
});

export const LeftGroup = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
  flex: 1,
});

export const RightGroup = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
});

export const IconActionBtn = styledMui(IconButton)(({ theme }) => ({
  width: "36px",
  height: "36px",
  borderRadius: "8px",
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "&.Mui-disabled": {
    color: theme.palette.text.disabled,
  },
}));
